// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2oTf2","load2":"Spinner_load2__38JW_"};